import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { formGroupPatchValueNullFriendly } from 'app/helpers/utils';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { AutoStartFileSettings, AutoStartFormSettings } from 'app/models/workflow-auto-start';
import { WorkflowFile } from 'app/models/workflow-file';
import { WorkflowForm } from 'app/models/workflow-form';
import { WorkflowTemplate } from 'app/models/workflow-template';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { finalize } from 'rxjs/operators';
import { AddEditAutoStartFileComponent } from '../add-edit-auto-start-file/add-edit-auto-start-file.component';
import { AddEditAutoStartFormComponent } from '../add-edit-auto-start-form/add-edit-auto-start-form.component';

@Component({
  selector: 'app-add-edit-auto-start-rule',
  templateUrl: './add-edit-auto-start-rule.component.html',
  styleUrls: ['./add-edit-auto-start-rule.component.scss']
})
export class AddEditAutoStartRuleComponent implements OnInit {

  constructor(private validationHandler: ValidationHandler, private workflowTemplateService: WorkflowTemplateService, private workflowWizardService: WorkflowWizardService) { }

  @Input() isInitialStepCompletion: boolean = false;

  workflowTemplates: WorkflowTemplate[] = [];
  isLoadingWorkflow: boolean = false;

  ngOnInit(): void {
    this.isLoadingWorkflow = true;
    this.workflowTemplateService.getAll(false, true).pipe(finalize(() => this.isLoadingWorkflow = false)).subscribe((w) => {
      if (this.isInitialStepCompletion) {
        w.splice(w.indexOf(this.workflowWizardService.workflowTemplateFormGroup.value.name));
      }
      this.workflowTemplates = w;
    });
  }

  @ViewChild('addEditAutoStartModal', { static: true }) addEditAutoStartModal: ModalDirective;
  @ViewChild('addEditAutoStartFile', { static: true }) addEditAutoStartFile: AddEditAutoStartFileComponent;
  @ViewChild('addEditAutoStartForm', { static: true }) addEditAutoStartForm: AddEditAutoStartFormComponent;

  @Output() addEditAccepted: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  @Input() workflowForms: WorkflowForm[];
  @Input() workflowFiles: WorkflowFile[];
  @Input() isEdit: boolean;

  autoStartRuleToAddFormGroup: FormGroup;

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedFormsTableLimit: number = 100;
  selectedFilesTableLimit: number = 100;

  editFileIndex: number = -1;
  editFormIndex: number = -1;


  innerWidth() {
    return window.innerWidth;
  }
  
  show(frm: FormGroup) {
    this.autoStartRuleToAddFormGroup = frm;
    this.addEditAutoStartModal.show();
  }

  onOpened() {
  }
  
  loadWorkflowDetails(selectedWorkflowTemplate: WorkflowTemplate) {
    if (selectedWorkflowTemplate) {
      this.isLoadingWorkflow = true;
      this.workflowTemplateService.getById(selectedWorkflowTemplate.id, true).pipe(finalize(() => this.isLoadingWorkflow = false)).subscribe((w) => {
        this.autoStartRuleToAddFormGroup = this.workflowTemplateService.generateWorkflowAutoStartFormGroup(w);
      });
      
    }
  }

  onAddAutoStartModalAddClick() {
    this.validationHandler.onSubmitCheck(this.autoStartRuleToAddFormGroup);
    if(!this.autoStartRuleToAddFormGroup.valid){
      return;
    }

    this.addEditAccepted.emit(this.autoStartRuleToAddFormGroup);
    this.addEditAutoStartModal.hide();
  }

  editFile(file: AutoStartFileSettings, index: number){
    this.editFileIndex = index;
    let frmGroup: FormGroup = this.workflowTemplateService.getAutoStartFileFormGroup(file);
    formGroupPatchValueNullFriendly(frmGroup, file);
    this.addEditAutoStartFile.show(frmGroup);
  }

  removeFile(index: number){
    (<FormArray>this.autoStartRuleToAddFormGroup.controls['files']).removeAt(index);
  }

  
  onAddEditFileFinished(frm: FormGroup) {
    let autoStartFilesFormArray: FormArray = (<FormArray>this.autoStartRuleToAddFormGroup.controls['files']);
    if (this.editFileIndex != -1) {
      formGroupPatchValueNullFriendly(autoStartFilesFormArray.at(this.editFileIndex) as FormGroup, frm.value);
      this.editFileIndex = -1;
    } else {
      autoStartFilesFormArray.push(frm);
      frm.setParent(autoStartFilesFormArray);
    }
  }
  
  onAddFile() {
    this.editFileIndex = -1;
    let frmGroup: FormGroup = this.workflowTemplateService.getAutoStartFileFormGroup({is_additional_file: 1} as any);
    this.addEditAutoStartFile.show(frmGroup);
  }

  
  editForm(form: AutoStartFormSettings, index: number){
    this.editFormIndex = index;
    let frmGroup: FormGroup = this.workflowTemplateService.getAutoStartFormFormGroup(form);
    formGroupPatchValueNullFriendly(frmGroup, form);
    this.addEditAutoStartForm.show(frmGroup);
  }

  removeForm(index: number){
    (<FormArray>this.autoStartRuleToAddFormGroup.controls['forms']).removeAt(index);
  }

  
  onAddEditFormFinished(frm: FormGroup) {
    let autoStartFormsFormArray: FormArray = (<FormArray>this.autoStartRuleToAddFormGroup.controls['forms']);
    if (this.editFormIndex != -1) {
      formGroupPatchValueNullFriendly(autoStartFormsFormArray.at(this.editFormIndex) as FormGroup, frm.value);
      this.editFormIndex = -1;
    } else {
      autoStartFormsFormArray.push(frm);
      frm.setParent(autoStartFormsFormArray);
    }
  }
  
  onAddForm() {
    this.editFormIndex = -1;
    let frmGroup: FormGroup = this.workflowTemplateService.getAutoStartFormFormGroup({is_additional_form: 1, is_entire_form: 1} as any);
    this.addEditAutoStartForm.show(frmGroup);
  }
}
